export default __webpack_public_path__ + "static/media/setting-icon.72c874f9.svg";